import React, { useEffect, useRef } from "react"
import useGlobalContext from "../context/GlobalContext"

const WorksNav = () => {
  const { changeCursor, activeLink, setActiveLink } = useGlobalContext()
  const activeRef = useRef(null)
  const navRef = useRef(null)

  useEffect(() => {
    activeRef.current.style.width =
      navRef.current.children[activeLink].getBoundingClientRect().width + "px"
    activeRef.current.style.height =
      navRef.current.children[activeLink].getBoundingClientRect().height + "px"
    activeRef.current.style.left =
      navRef.current.children[activeLink].offsetLeft + "px"
  }, [activeLink])

  return (
    <div
      className="works-nav"
      onMouseEnter={() => changeCursor("hovered")}
      onMouseLeave={() => changeCursor("")}
    >
      <ul ref={navRef} className="flex">
        <li
          onClick={() => setActiveLink(0)}
          style={{ color: activeLink === 0 ? "#fff" : "#050709" }}
        >
          All
        </li>
        <li
          onClick={() => setActiveLink(1)}
          style={{ color: activeLink === 1 ? "#fff" : "#050709" }}
        >
          Narative
        </li>
        <li
          onClick={() => setActiveLink(2)}
          style={{ color: activeLink === 2 ? "#fff" : "#050709" }}
        >
          Music Videos
        </li>
        <li
          onClick={() => setActiveLink(3)}
          style={{ color: activeLink === 3 ? "#fff" : "#050709" }}
        >
          Commercials
        </li>
        <span
          ref={activeRef}
          style={{ "--position": `${activeLink}` }}
          className="active-tag"
        ></span>
      </ul>
    </div>
  )
}

export default WorksNav
